import { User } from 'app/user/types'

export const getInitials = (user: User) =>
  [user.firstName?.charAt(0).toUpperCase(), user.lastName?.charAt(0).toUpperCase()].join('') ??
  user.email?.charAt(0).toUpperCase()
